import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKx0224SapBuExportStatus: 'idle',
    startProcessKx0224SapBuExportError: undefined as any,
    loadUserParamsProcessKx0224SapBuExportStatus: 'idle',
    loadUserParamsProcessKx0224SapBuExportError: undefined as any,

    processKx0224SapBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKx0224SapBuExport = createAsyncThunk('processKx0224SapBuExportSlice/startProcessKx0224SapBuExport', async ({ processKx0224SapBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKx0224SapBuExport/`,
        prepareData(processKx0224SapBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKx0224SapBuExportStatus } = getState().processKx0224SapBuExportSlice
        return startProcessKx0224SapBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKx0224SapBuExport = createAsyncThunk('processKx0224SapBuExportSlice/loadUserParamsProcessKx0224SapBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKx0224SapBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKx0224SapBuExportStatus } = getState().processKx0224SapBuExportSlice
        return loadUserParamsProcessKx0224SapBuExportStatus !== 'pending'
    }
})

const ProcessKx0224SapBuExportSlice = createSlice({
    name: 'processKx0224SapBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKx0224SapBuExport: (state) => {
            state.job = undefined
            state.startProcessKx0224SapBuExportError = undefined
        },
        resetstartProcessKx0224SapBuExportError: (state) => {
            state.startProcessKx0224SapBuExportError = undefined
        },
        resetloadUserParamsProcessKx0224SapBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKx0224SapBuExportError = undefined
        },
        resetloadUserParamsProcessKx0224SapBuExportError: (state) => {
            state.loadUserParamsProcessKx0224SapBuExportError = undefined
        },
        removeFromProcessKx0224SapBuExportListById: (state, action) => {
            state.processKx0224SapBuExportList = state.processKx0224SapBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKx0224SapBuExportListByIds: (state, action) => {
            state.processKx0224SapBuExportList = state.processKx0224SapBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKx0224SapBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKx0224SapBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKx0224SapBuExportList = []
            state.startProcessKx0224SapBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKx0224SapBuExport.pending, (state) => {
            state.startProcessKx0224SapBuExportStatus = 'pending'
            state.startProcessKx0224SapBuExportError = undefined
        })
        builder.addCase(startProcessKx0224SapBuExport.fulfilled, (state, action) => {
            state.startProcessKx0224SapBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKx0224SapBuExport.rejected, (state, action) => {
            state.startProcessKx0224SapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKx0224SapBuExportError = action.error.message
            } else {
                state.startProcessKx0224SapBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKx0224SapBuExport.pending, (state) => {
            state.loadUserParamsProcessKx0224SapBuExportStatus = 'pending'
            state.loadUserParamsProcessKx0224SapBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKx0224SapBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKx0224SapBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKx0224SapBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKx0224SapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKx0224SapBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKx0224SapBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKx0224SapBuExport,
    resetstartProcessKx0224SapBuExportError,
    resetloadUserParamsProcessKx0224SapBuExport,
    resetloadUserParamsProcessKx0224SapBuExportError,
    removeFromProcessKx0224SapBuExportListById,
    removeFromProcessKx0224SapBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKx0224SapBuExportSlice.actions
export default ProcessKx0224SapBuExportSlice.reducer
